import dateFormat from "dateformat";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { IMAGE_BASE_URL } from "../data/baseURL";
import blog from "../images/blog/NEWS.png";

const Blog = ({ magazine }) => {
  const navigate = useNavigate();
  return (
    <section className="container-fluid mt-17">
      <div className="ms-13 me-13">
        <div className="position-relative text-center">
          <h1 className="fs-56 gilroy-bold text-center text-charleston-green">
            Afro Magazine
          </h1>
          <div className="position-absolute blog-img-position">
            <img src={blog} className="blog-img" loading="lazy" alt="" />
          </div>
        </div>
        <div className="row mt-7 d-flex justify-content-center">
          {magazine?.slice(0, 6)?.map((data, index) => (
            <article className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
              <div
                className="h-100 blog-card review-shadow rounded-lg position-relative cursor-pointer"
                onClick={() => navigate(`/magazine/${data?.id}`)}
              >
                <div className="position-relative">
                  <img
                    src={`${IMAGE_BASE_URL}/${data?.image}`}
                    className="card-img-top w-full d-block"
                    style={{ borderRadius: "10px 10px 0 0" }}
                    loading="lazy"
                    alt="..."
                  />
                  <p
                    className="blog-img-text fs-16 bg-american-yellow text-white fw-700 text-capitalize"
                    style={{ borderRadius: "10px 0 0 0" }}
                  >
                    {data?.heading}
                  </p>
                </div>
                <div className="card-body blog-card-body-padding fs-20">
                  <p className="text-end fs-16">
                    {dateFormat(data?.created_at, "dS mmmm, yyyy")}
                  </p>
                  <p className="fs-22 gilroy-bold text-charleston-green text-capitalize">
                    {data?.title}
                  </p>
                  {/* <p className="text-spanish-gray">{data?.short_description}</p> */}
                  <p
                    className="text-spanish-gray fs-16"
                    dangerouslySetInnerHTML={{ __html: data?.sort_description }}
                  />
                  <p>
                    <Link
                      className="btn-card fs-14 fw-700 text-uppercase"
                      to={`/magazine/${data?.id}`}
                    >
                      Read More
                    </Link>
                  </p>
                </div>
                <div className="review-card-border"></div>
              </div>
            </article>
          ))}
        </div>
        <div className="text-center mt-5 pt-4 mx-5">
          <Link
            to="/all-magazine"
            className="text-uppercase px-5 py-4 fs-14 bg-american-yellow text-white text-decoration-none"
          >
            See more
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blog;
